/**
 * MomentJS flight component
 */
import { component as defineComponent } from 'flightjs';
import moment from 'moment';

// Evil magic globals
import 'moment/locale/en-gb';
import 'moment/locale/en-au';
import 'moment/locale/en-ca';
import 'moment/locale/es';
import 'moment/locale/de';
import 'moment/locale/it';
import 'moment/locale/ja';
import 'moment/locale/pt';
import 'moment/locale/fr';

function MomentWatcher() {
    this.attributes({
        // new apps use time[datetime], Monolith uses .gmttime
        timeSelector: 'time[datetime], .gmttime',
        absoluteTimeSelector: 'time[datetime][data-absolute-time]',
        processedAttr: 'data-moment-processed',
        locale: false,
        cacheProcessedTimes: true
    });

    this.after('initialize', function() {
        moment.locale(this.attr.locale || this.$node.data('locale'));
        this.on(document, 'uiNeedsTimeUpdate', this.process);
        this.process();
    });

    this.process = function(e, data) {
        // absolute time
        this.selectChildren('absoluteTimeSelector').each(function(i, elm) {
            $(elm)
                .attr('title', this.getMomentString($(elm)))
                .attr(this.attr.processedAttr, '')
                .text(moment(this.nodeTime(elm)).format('ll'));
        }.bind(this));

        // relative time
        this.selectChildren('timeSelector').each(function(i, elm) {
            $(elm)
                .attr('title', moment(this.nodeTime($(elm))).format('LLL'))
                .attr(this.attr.processedAttr, '')
                .text(this.getMomentString($(elm)));
        }.bind(this));
    };

    this.selectChildren = function(selector) {
        var children = this.select(selector);

        if (this.attr.cacheProcessedTimes) {
            children = children.not('[' + this.attr.processedAttr + ']');
        }

        return children;
    };

    this.getMomentString = function($node) {
        var suppressSuffix = $node.attr('data-no-suffix') !== undefined;
        return moment(this.nodeTime($node)).fromNow(suppressSuffix);
    };

    this.nodeTime = function(node) {
        var $node = $(node);
        return ($node.attr('datetime')) ? $node.attr('datetime') : $node.text();
    };
};

export default defineComponent(MomentWatcher);



// WEBPACK FOOTER //
// ./node_modules/@99designs/brand-container/lib/ui/relative-time.js